import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Warning = forwardRef<SVGSVGElement | null, IconFilledProps>(function Warning({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M11.75 14C11.75 14.2761 11.9739 14.5 12.25 14.5H12.75C13.0261 14.5 13.25 14.2761 13.25 14V6.5C13.25 6.22386 13.0261 6 12.75 6H12.25C11.9739 6 11.75 6.22386 11.75 6.5V14Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          d='M12.5 18C13.0523 18 13.5 17.5523 13.5 17C13.5 16.4477 13.0523 16 12.5 16C11.9477 16 11.5 16.4477 11.5 17C11.5 17.5523 11.9477 18 12.5 18Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12ZM21 12C21 16.6944 17.1944 20.5 12.5 20.5C7.80558 20.5 4 16.6944 4 12C4 7.30558 7.80558 3.5 12.5 3.5C17.1944 3.5 21 7.30558 21 12Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22ZM11.75 14C11.75 14.2761 11.9739 14.5 12.25 14.5H12.75C13.0261 14.5 13.25 14.2761 13.25 14V6.5C13.25 6.22386 13.0261 6 12.75 6H12.25C11.9739 6 11.75 6.22386 11.75 6.5V14ZM12.5 18C13.0523 18 13.5 17.5523 13.5 17C13.5 16.4477 13.0523 16 12.5 16C11.9477 16 11.5 16.4477 11.5 17C11.5 17.5523 11.9477 18 12.5 18Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'warning-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Warning;
